// Exports
export default {
	"mainWrapper": "mainWrapper_ICCSI",
	"soundWrapper": "soundWrapper_10Vg7",
	"diagnosticContainer": "diagnosticContainer_D2AEq",
	"isMobile": "isMobile_sF3zH",
	"diagnosticBtn": "diagnosticBtn_20Hv0",
	"headingWrapper": "headingWrapper_kVuJA",
	"noiseCancellationSelectPopup": "noiseCancellationSelectPopup_tBzLH",
	"inputDiagnosticButtonTooltip": "inputDiagnosticButtonTooltip_sNn2P",
	"noAccessWrapper": "noAccessWrapper_Blpfe",
	"noAccessIcon": "noAccessIcon_13uAn"
};
